import * as Sentry from '@sentry/vue'
import router from '@/router'

export default {
  install(app: any) {
    if (!import.meta.env.VITE_APP_SENTRY_DSN) {
      return
    }
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_APP_SENTRY_DSN,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      tracesSampleRate: 1.0,
      attachStacktrace: true,
      normalizeDepth: 3,
      integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
      ignoreErrors: [
        'Load failed',
        'NetworkError',
        'Tab not found',
        'Expected mapDiv',
        'Unable to preload',
        'Failed to send the request',
        'Object captured as promise rejection with keys',
        'Object Not Found Matching Id:',
        'Google Maps JavaScript API',
        'Failed to load Google Maps',
        'Could not load "onion"',
        'InvalidValueError',
        'No error message',
        'invalid origin', //DDG do not send origin we can ignore it
        'Maximum call stack size exceeded.',
        'No identifiers allowed directly after numeric literal',
        'feature named `pageObserver` was not found',
        'feature named `pageContext` was not found',
        'Invalid call to browser.storage.local.set()',
        'uncaught exception: undefined',
        "can't access lexical declaration",
        'WKWebView API client did not respond to this postMessage',
      ],
      beforeSend(event, hint) {
        try {
          const m = event.message || ''
          const ex = (event.exception?.values?.[0] || { type: '', value: '' }) as any
          const exType = ex?.type || ''
          const exValue = ex?.value || ''

          const frames = event.exception?.values?.flatMap((v) => v.stacktrace?.frames || []) || []
          const isGoogleApisScript = frames.some((f) => f.filename?.includes('googleapis.com'))

          return m === 'db' ||
            m === 'No error message' ||
            exType === 'InvalidValueError' ||
            exType === 'NetworkError' ||
            exValue === 'No error message' ||
            isGoogleApisScript ||
            (hint?.originalException as any)?.response?.status === 0 ||
            (hint?.originalException as any)?.status === 0 ||
            (hint?.originalException as any)?.code === 'ERR_NETWORK'
            ? null
            : event
        } catch {
          return event
        }
      },
    })
  },
}
